import vertexShader from "./manidesto-distort.vert";
import fragmentShader from "./manidesto-distort.frag";
import { DoubleSide } from "three";

const ManifestoDistortShader = {
  uniforms: {
    tDiffuse: { value: null },
    uVisibilityProgress: { value: 0.0 },
    uTime: { value: 0 },
    uScale: { value: 0.5 },
    uAr: { value: 1.777 },
    uSeed: { value: 0.0 },
  },
  transparent: true,
  vertexShader,
  fragmentShader,
  side: DoubleSide,
  depthWrite: false,
  depthTest: false,
};

export default ManifestoDistortShader;
